import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { triggerGlobalTooltipScan } from "./global-onboarding-tooltip-manager";
import { isOnboardingPublicRoute } from "./is-public-route";

// Route changes can swap whole views without a mutation the scanner treats as relevant
// (e.g. only attributes/styles change), so each navigation asks for one fresh scan.
export const RouteChangeTooltipListener = (): null => {
  const location = useLocation();
  const isFirstRender = useRef<boolean>(true);

  useEffect((): void => {
    if (isOnboardingPublicRoute(location.pathname)) {
      return;
    }

    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    triggerGlobalTooltipScan();
  }, [location.pathname, location.search, location.hash]);

  return null;
};
